import React, {Fragment } from 'react';
import {TPublicationList} from './Publications';
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'


const API_URL = process.env.REACT_APP_API_URL

interface PublicationListProps {
    items: TPublicationList, // don't have to redeclare the object again
};

const PublicationList: React.FC<PublicationListProps> = (props) => {

    return (
        <Fragment>
            {props.items.map(publication => (
                <tr key={publication.nid}>
                    <td>
                        <div className='d-flex align-items-center'>
                            <div className='d-flex justify-content-start flex-column'>
                                <span className='text-dark fw-bolder text-hover-primary mb-1 fs-7'>
                                {publication.title}
                                </span>
                                <span className='text-muted fw-bold text-muted d-block fs-7'>
                                {publication.field_authors}
                                </span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.field_category}</span>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.field_review.replaceAll('&amp;', '&').replaceAll('&#039;', "'")}</span>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.field_publication_date}</span>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.changed}</span>
                    </td>
                    <td className='text-end'>
                        <Link to={'/publications/edit/'+publication.nid} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-2'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                        </Link>
                        {publication.field_files !== '' &&
                        <a
                            download={publication.title}
                            target='_blank'
                            rel='noreferrer'
                            href={API_URL + publication.field_files}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-2'
                        >
                            <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-3' />
                        </a>
                        }
                    </td>
                </tr>
            ))}
            
        </Fragment>
    );
};

export default PublicationList;